module.exports = __webpack_public_path__ + "static/img/zoom_btn5.cf80167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/zoom_btn5.png
// module id = ozgt
// module chunks = 4